import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class NotificationAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'Notifications';

  /**
   * Lấy dữ liệu đã đã thông báo
   */
  getList(payload) {
    let request = {
      url: this.getAPIUrl() + '/Paging',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu đã đã thông báo
   */
  updateRead(payload) {
    let request = {
      url: this.getAPIUrl() + '/read',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  getUnread(payload) {
    let request = {
      url: this.getAPIUrl() + '/unread',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  isMacNoti(payload) {
    let request = {
      url: this.getAPIUrl() + '/isMacNoti',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy chi tiết ISMAC
   */
  iSMACDetail(payload) {
    let request = {
      url: this.getAPIUrl() + '/isMacDetail',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Udate dữ liệu ban hành
   */
  updateReadEnact() {
    let request = {
      url: this.getAPIUrl() + '/readEnact',
    };
    return httpClient.postAsync(request);
  }

  /**
   * Udate dữ liệu ban hành
   */
  updateReadAllocationDecision() {
    let request = {
      url: this.getAPIUrl() + '/readAllocationDecision',
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy số thông báo trần chi chưa đọc + ID lần nộp trần chi gần nhất
   * vqphong - 19/08/2024
   */
  getUnreadCeilingExpense() {
    let request = {
      url: this.getAPIUrl() + '/unread-ceiling-expense',
    };
    return httpClient.getAsync(request);
  }

  /**
   * Đọc toàn bộ thông báo trần chi chưa đọc
   * vqphong - 23/08/2024
   */
  updateReadCeilingExpense() {
    let request = {
      url: this.getAPIUrl() + '/read-ceiling-expense',
    };
    return httpClient.postAsync(request);
  }
}

export default new NotificationAPI();
